import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { getTrackByFn } from '@y42/angular/util';

interface Tab {
  path: string;
  name: string;
}

@Component({
  selector: 'y42-context-menu-move-to-tab',
  templateUrl: './context-menu-move-to-tab.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContextMenuMoveToTabComponent {
  @Input()
  tabs!: Tab[];

  @Input()
  activeTab!: string;

  @Output()
  moveToTab = new EventEmitter<string>();

  readonly trackByName = getTrackByFn<Tab>('name');
}
